/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Cloud_Voice_BadgeInputs */

const en_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud voice`)
};

const fr_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix cloud`)
};

const de_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Stimme`)
};

const it_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voce cloud`)
};

const ru_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облачный голос`)
};

const es_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz en la nube`)
};

const zh_cn2_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云端语音`)
};

const ja_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウド音声`)
};

const hi_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लाउड आवाज़`)
};

const pt_pt2_voice_manager_cloud_voice_badge = /** @type {(inputs: Voice_Manager_Cloud_Voice_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz na nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud voice" |
*
* @param {Voice_Manager_Cloud_Voice_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_cloud_voice_badge = /** @type {((inputs?: Voice_Manager_Cloud_Voice_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Cloud_Voice_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_cloud_voice_badge(inputs)
	if (locale === "de") return de_voice_manager_cloud_voice_badge(inputs)
	if (locale === "it") return it_voice_manager_cloud_voice_badge(inputs)
	if (locale === "ru") return ru_voice_manager_cloud_voice_badge(inputs)
	if (locale === "es") return es_voice_manager_cloud_voice_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_cloud_voice_badge(inputs)
	if (locale === "ja") return ja_voice_manager_cloud_voice_badge(inputs)
	if (locale === "hi") return hi_voice_manager_cloud_voice_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_cloud_voice_badge(inputs)
	return en_voice_manager_cloud_voice_badge(inputs)
});